<template>
  <svg width="40px" height="40px" viewBox="0 0 24.00 24.00" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="🔍-Product-Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="ic_fluent_clipboard_text_24_regular"
         :fill="color"
         fill-rule="nonzero"
      >
        <path
            d="M13.75,2 C14.940864,2 15.9156449,2.92516159 15.9948092,4.09595119 L16,4.25 L16,4.25 C16,4.16530567 15.9953205,4.0817043 15.9862059,3.99944035 L17.75,4 C18.9926407,4 20,5.00735931 20,6.25 L20,19.75 C20,20.9926407 18.9926407,22 17.75,22 L6.25,22 C5.00735931,22 4,20.9926407 4,19.75 L4,6.25 C4,5.00735931 5.00735931,4 6.25,4 L8.01379413,3.99944035 C8.00733496,4.05773764 8.00310309,4.11670658 8.00118552,4.17626017 L8,4.25 C8,3.00735931 9.00735931,2 10.25,2 L13.75,2 Z M13.75,6.5 L10.25,6.5 C9.45594921,6.5 8.75796956,6.08867052 8.357512,5.4674625 L8.37902077,5.50019943 L8.37902077,5.50019943 L6.25,5.5 C5.83578644,5.5 5.5,5.83578644 5.5,6.25 L5.5,19.75 C5.5,20.1642136 5.83578644,20.5 6.25,20.5 L17.75,20.5 C18.1642136,20.5 18.5,20.1642136 18.5,19.75 L18.5,6.25 C18.5,5.83578644 18.1642136,5.5 17.75,5.5 L15.6209792,5.50019943 L15.642488,5.4674625 C15.2420304,6.08867052 14.5440508,6.5 13.75,6.5 Z M13.75,3.5 L10.25,3.5 C9.83578644,3.5 9.5,3.83578644 9.5,4.25 C9.5,4.66421356 9.83578644,5 10.25,5 L13.75,5 C14.1642136,5 14.5,4.66421356 14.5,4.25 C14.5,3.83578644 14.1642136,3.5 13.75,3.5 Z M8,14.5 L12,14.5 C12.4142136,14.5 12.75,14.1642136 12.75,13.75 C12.75,13.3357864 12.4142136,13 12,13 L8,13 C7.58578644,13 7.25,13.3357864 7.25,13.75 C7.25,14.1642136 7.58578644,14.5 8,14.5 Z M8,10.5 L16,10.5 C16.4142136,10.5 16.75,10.1642136 16.75,9.75 C16.75,9.33578644 16.4142136,9 16,9 L8,9 C7.58578644,9 7.25,9.33578644 7.25,9.75 C7.25,10.1642136 7.58578644,10.5 8,10.5 Z M8,18.5 L14,18.5 C14.4142136,18.5 14.75,18.1642136 14.75,17.75 C14.75,17.3357864 14.4142136,17 14,17 L8,17 C7.58578644,17 7.25,17.3357864 7.25,17.75 C7.25,18.1642136 7.58578644,18.5 8,18.5 Z"
            id="🎨-Color"></path>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#fff"
    },
    width: {
      type: String,
      default: "35"
    },
    height: {
      type: String,
      default: "35"
    }
  }
};
</script>

<style lang="scss" scoped>
</style>